import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProductionSiteNotes({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate
        const query = payload.query
        
        commit('GET_PRODUCTION_SITE_NOTES_REQUEST')

        return axios
            .get(`/production-sites/production-site-notes${paginate}${query}`)
            .then(response => {
                commit('GET_PRODUCTION_SITE_NOTES_SUCCESS', response.data)
                
                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCTION_SITE_NOTES_FAILURE')
                handleApiError(error, 'Pobranie notek stanowiskowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUnreadProductionSiteNotes({ commit }, userId) {
        return axios
            .get(`/production-sites/production-site-notes?unreadBy_id=${userId}`)
            .then(response => {
                
                commit('GET_UNREAD_PRODUCTION_SITE_NOTES_SUCCESS', response.data.count)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCTION_SITE_NOTES_FAILURE')
                handleApiError(error, 'Pobranie notek stanowiskowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionSiteNote(context, id) {
        return axios
            .get(`/production-sites/production-site-notes/${id}`)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych notki stanowiskowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUnreadProductionSiteNotesAmount(context, id) {
        return axios
            .get(`/production-sites/production-site-unread-notes/${id}`).
            then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie ilości nieodczytanych notek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createProductionSiteNote({ commit }, productionSiteNoteData) {
        return axios
            .post('/production-sites/production-site-notes', productionSiteNoteData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Notka stanowiskowa została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie notki stanowiskowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProductionSiteNote({ commit }, productionSiteNoteData) {
        return axios
            .put(`/production-sites/production-site-notes/${productionSiteNoteData.id}`, productionSiteNoteData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Edytowano notkę stanowiskową.'
                }, { root: true })

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Edycja notki stanowiskowej nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteProductionSiteNote({ commit }, id) {
        return axios
            .delete(`/production-sites/production-site-notes/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Notka stanowiskowa została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie notki stanowiskowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createProductionSiteNoteComment({ commit }, payload) {
        return axios
            .post('/production-sites/production-site-note-comments', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano komentarz.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setProductionSiteNotesFilters({ commit }, filters) {
        commit('SET_FILTERS', filters)
    },
    clearProductionSiteNotesFilters({ commit }) {
        commit('CLEAR_FILTERS')
    },
    setUnreadProductionSiteNoteCount({ commit }, count) {
        commit('GET_UNREAD_PRODUCTION_SITE_NOTES_SUCCESS', count)
    }
}